<template>
  <div>
    <div class="container">
      <p id="dashboardItemTitle">Edit Template</p>
      <!--first step-->
      <div class="card" v-if="firstStep">
        <div class="card-content">
          <div class="content">
            <section>

              <b-field horizontal
                       :type="invalidName  == '' ? '' : 'is-danger'"
                       :message="invalidName">
                <template slot="label">Template Name<span class="has-text-danger">*</span></template>
                <b-input @input="resetInvalidStatus('invalidName')" v-model="formData.name"></b-input>
              </b-field>

              <b-field horizontal
                       :type="invalidDepartment  == '' ? '' : 'is-danger'"
                       :message="invalidDepartment">
                <template slot="label">Department<span class="has-text-danger">*</span></template>
                <b-select placeholder="Select a Department" expanded @input="resetInvalidStatus('invalidDepartment')"
                          v-model="formData.department">
                  <option
                      v-for="option in departmentList "
                      :value="option.name"
                      :key="option.id">
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>


              <b-field horizontal
                       :type="invalidTemplateCategory  == '' ? '' : 'is-danger'"
                       :message="invalidTemplateCategory">
                <template slot="label">Template Category<span class="has-text-danger">*</span></template>
                <b-select placeholder="Select a Template Category"
                          v-model="formData.template_category" expanded
                          @input="resetInvalidStatus('invalidTemplateCategory')">
                  <option
                      v-for="option in templateCategoryList"
                      :value="option.name"
                      :key="option.id">
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>

              <b-field horizontal>
                <div class="block"></div>
              </b-field>

              <div class="tile custom-tile-narrow">
                <div class="column">
                  <div class="columns">
                    <div class="column">
                      <p class="has-text-danger is-italic">Fields marked with <big>*</big> are mandatory</p>
                    </div>
                    <div class="buttons">
                      <b-button  :loading="formIsSubmitting" type="is-success" @click="validateAndSubmit()">Save</b-button>
                      <b-button @click="$navigate(-1)"  type="is-danger">Cancel</b-button>
                    </div>
                  </div>
                </div>
              </div>

            </section>
          </div>
        </div>
      </div>
    </div>

    <div class="columns" v-if="firstStep ==false">
      <div class="column is-4 is-offset-8">
        <b-field class="file is-primary" style="margin-left: 20px">
          <b-upload v-model="file" class="file-label" @input="filechange()">
                  <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                  </span>
          </b-upload>
        </b-field>
      </div>
    </div>


    <!-- second step-->
    <div class="columns" v-if="firstStep ==false">

      <div id="drop-zone" class="drop-zone" @click="mouseClickMove($event,elementId)">
        <!--textboxes---------------------------------------------------------------------------------------->
        <div v-for="box in textBoxes" :key="box.id" :id="box.id" class="draggable" >
          <button class="delete" type="button" @click="openPlaceholderRemove(box.id,'text-box')"></button>
          <label style="text-align:left;font-size: 10px">{{box.inviteeName}}</label> <br>
          <b-tag type="is-info" >text-box {{box.id}}</b-tag>
        </div>

        <!--signatures---------------------------------------------------------------------------------------->
        <div v-for="sign in signatures" :key="sign.id" :id="sign.id" class="draggable">
          <button  class="delete" type="button" @click="openPlaceholderRemove(sign.id,'signature')"></button>
          <label style="text-align:left;font-size: 10px">{{sign.inviteeName}}</label> <br>
          <b-tag type="is-primary">Signature {{sign.id}}</b-tag>
        </div>

        <!--checkBox---------------------------------------------------------------------------------------->
        <div v-for="checkbox in checkboxes" :key="checkbox.id" :id="checkbox.id" class="draggable">
          <button  class="delete" type="button" @click="openPlaceholderRemove(checkbox.id,'check-box')"></button>
          <label style="text-align:left;font-size: 10px">{{checkbox.inviteeName}}</label> <br>
          <b-tag  type="is-success">checkbox {{checkbox.id}}</b-tag>
        </div>

        <!--datepickers---------------------------------------------------------------------------------------->
        <div v-for="datepicker in datepickers" :key="datepicker.id" :id="datepicker.id" class="draggable">
          <button class="delete" type="button" @click="openPlaceholderRemove(datepicker.id,'date-picker')"></button>
          <label style="text-align:left;font-size: 10px">{{datepicker.inviteeName}}</label> <br>
          <b-tag  type="is-warning">Date-picker {{datepicker.id}}</b-tag>
        </div>
        <canvas :id="'the-canvas'+render" style="width: 100%; height: 100%;border: 1px solid black" v-for="render in TotPage" :key="render.id"></canvas>
      </div>


      <div class="column is-4" v-if="firstStep ==false">
        <div class="box">
          <div class="placeholder-card" style="padding: 10px">
            <p style="text-align: left; font-weight: bold; font-size: 20px" class="mt-2">Place Holders</p>
            <b-button expanded class="mt-3" @click="addElements('text-box')">Textfield</b-button>
            <b-button expanded class="mt-3" @click="addElements('signature')">Signature</b-button>
            <b-button expanded class="mt-3" @click="addElements('checkbox')">Checkbox</b-button>
            <b-button expanded class="mt-3" @click="addElements('date-picker')">Date</b-button>

            <hr style="border-top: 1px solid #A5A6B3;">
            <div class="mt-3">
              <div class="columns">
                <div class="column">
                  <b-button outlined rounded expanded type="is-primary" @click="savePDFwithCoordinates()">Save </b-button>
                </div>
                <div class="column">
                  <b-button rounded expanded>Cancel</b-button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!--placeholder remove component-->
    <b-modal v-model="showPlaceholderRemoveModal" :width="400"  animation="zoom-out">
      <div class="model-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Warning !</p>
          <button type="button" class="delete" @click="showPlaceholderRemoveModal = false"></button>
        </header>

        <div class="modal-card-body">
          <div class="content pt-2">
            <div>
              Do you want to remove this placeholder?
            </div>

            <div style="margin-top: 40px">
              <div class="columns">
                <div class="column">
                  <b-button type="is-danger" rounded expanded outlined @click="removePlaceholders(placeholderID,placeholderType)">Yes</b-button>
                </div>
                <div class="column">
                  <b-button type="is-info" rounded expanded outlined @click="showPlaceholderRemoveModal = false">No</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

  </div>
</template>
<script>
// import axios from "axios";

import axios from "axios";
import * as pdfjsLib from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'

export default {

  name:'template-edit',



  data(){
    return {
      departmentList:[],
      templateCategoryList:[],
      formIsSubmitting:false,

      invalidName:'',
      invalidDepartment:'',
      invalidTemplateCategory:'',

      formData:{
        id:'',
        name:'',
        department:null,
        template_category:null
      },

      currentFileUrl:'',
      document_url:'', //db url

      regex:{
        name: /^[a-zA-Z][a-zA-Z ]+$/,
      },

      formIsInvalid:false,
      templateID:'',

      firstStep:true,

      TotPage:0,
      Pageindex:[],

      textBoxes:[],
      signatures:[],
      checkboxes:[],
      datepickers:[],

      oldCoordinates:[],
      coordinates:[],
      elementId:0,

      showPlaceholderRemoveModal:false,

      coordinateAdjustRatio:{
        x:1,
        y:1.035,
      },

      file:'',
    }
  },

  methods:{

    mouseClickMove: function (event,elementID){

      if(elementID <= 1){
        var target = document.getElementById(0);
        var xposition = (event.pageX - target.offsetLeft - target.offsetWidth/2);
        var yposition = (event.pageY- target.offsetTop - target.offsetHeight/2);
        target.style.transform = "translate("+ xposition + "px," + yposition + "px)";
        console.log('equal to 1---'+elementID)

      }else{
        console.log('more than 1---'+elementID--)
        var id = elementID--
        console.log('id----------'+id)
        target = document.getElementById(id);
        xposition = (event.pageX - target.offsetLeft - target.offsetWidth/2);
        yposition = (event.pageY- target.offsetTop - target.offsetHeight/2);
        target.style.transform = "translate("+ xposition + "px," + yposition + "px)";
      }

      console.log('x pos---'+xposition)
      console.log('y pos---'+yposition)

    },

    openPlaceholderRemove:function (elementID,type){
      var comp = this
      comp.showPlaceholderRemoveModal = true
      comp.placeholderID = elementID
      comp.placeholderType = type
    },

    removePlaceholders:function (id,type){
      var comp = this

      if(type == 'text-box'){
        comp.textBoxes.forEach((txtbox,index) =>{
          if(txtbox.id == id){
            comp.elementId --
            comp.textBoxes.splice(index, 1);
          }
        })
      }else if(type == 'signature'){
        comp.signatures.forEach((signature,index) =>{
          if(signature.id == id){
            comp.elementId --
            comp.signatures.splice(index, 1);
          }
        })
      }else if(type == 'date-picker'){
        comp.datepickers.forEach((datepick,index) =>{
          if(datepick,id == id){
            comp.elementId --
            comp.datepickers.splice(index, 1);
          }
        })
      }else if(type  == 'check-box'){
        comp.checkboxes.forEach((checkbox,index) =>{
          if(checkbox.id == id){
            comp.elementId --
            comp.checkboxes.splice(index, 1);
          }
        })
      }
      comp.showPlaceholderRemoveModal = false
    },

    //validate and add an elemnts into canvas
    addElements: function(elementType){
      var component = this


      if(elementType == 'text-box'){
        component.textBoxes.push(
            {
              id:component.elementId++,
              text:'value',
              type:'text-box',
              value:'',
            }
        )
      }else if(elementType == 'signature'){
        component.signatures.push(
            {
              id:component.elementId++,
              text:'',
              type:'signature',
              value:'',
            }
        )
      }else if(elementType == 'checkbox'){
        component.checkboxes.push(
            {
              id:component.elementId++,
              text:'',
              type:'checkbox',
              value:'',
            }
        )
      }else if(elementType == 'date-picker'){
        component.datepickers.push(
            {
              id:component.elementId++,
              text:'',
              type:'date-picker',
              value:'',
            }
        )
      }
    },

    filechange:function (){
      var component = this

      const filesize = Math.round(( event.target.files[0].size / 1024));
      if(event.target.files[0].type == 'application/pdf'){
        if (filesize >= 50000) {
          component.$buefy.toast.open({
            message: 'Please select a file less than 50mb',
            type: 'is-danger',
            duration:2000
          })

        } else {
          // component.filename = "Selected File: " + event.target.files[0].name;
          component.currentFileUrl = URL.createObjectURL(event.target.files[0])
          component.file = event.target.files[0]
          component.showDocumentUpload = false
          component.renderPDF()
        }
      }else{
        component.$buefy.toast.open({
          message: 'Invalid Document Type',
          type: 'is-danger',
          duration:2000
        })
      }
    },


    resetInvalidStatus: function(key){

      this[key] = ''
      this.formIsInvalid = false
    },

    //department & category
    getDataList:function (){
      const comp = this
      try {

        axios.post(comp.$base_url+'/agent/getDataListforDropdown', {
          auth_token:comp.$root.agentAuthToken,
        })
            .then(function (response) {
              console.log(response)
              comp.departmentList = response.data.departmentList
              comp.templateCategoryList = response.data.categoryList
            })
            .catch(function (error) {
              console.log(error)

              comp.$buefy.toast.open({
                message: "Failed to get departments",
                type: "is-danger",
              });
            });

      }
      catch (e) {
        comp.$buefy.toast.open({
          message: "Failed to get departments",
          type: "is-danger",
        });
        console.log("Exception occurred in getDepartmentList() : "+e.message)
      }
    },

    getItemforEdit:function (){
      const comp = this
      try {

        axios.post(comp.$base_url+'/agent/getItemforEdit', {
          auth_token:comp.$root.agentAuthToken,
          template_id:comp.$route.params.id
        })
            .then(function (response) {
              var originalRecord = []
              originalRecord = response.data.data

              comp.formData.department        = originalRecord.department
              comp.formData.template_category = originalRecord.template_category
              comp.formData.name              = originalRecord.template_name
              comp.document_url               = originalRecord.document_path
              comp.oldCoordinates             = originalRecord.coordinates
              comp.elementId                  = originalRecord.coordinates.length
              comp.formData.id                = originalRecord.id

            })
            .catch(function (error) {
              console.log(error)

              comp.$buefy.toast.open({
                message: "Failed to load template data",
                type: "is-danger",
              });
            });

      }
      catch (e) {
        comp.$buefy.toast.open({
          message: "Something went wrong!",
          type: "is-danger",
        });
        console.log("Exception occurred in getItemforEdit() : "+e.message)
      }
    },

    //add placeholders to body
    AppendPlaceholdersToBody:function (elementID,type,Xcord,Ycord){
      var component = this
      console.log('append body')

      Xcord = (Xcord)*component.coordinateAdjustRatio.x
      Ycord = (Ycord)*component.coordinateAdjustRatio.y
      var elm = document.getElementById(elementID);
      console.log(elm)

      if(type == 'signature'){
        elm.style.border='none';

      }else if(type == 'date-picker'){

        elm.style.border='none';

      }

      elm.style.left = Xcord+'px'
      elm.style.top = Ycord+'px'
      elm.style.padding =10+'px'
      elm.style.position='absolute';
      elm.style.display='inline';

    },

    validateForm:function (){
      var formIsValid = true

      // Role Name
      if(this.formData.name.trim().length === 0){
        this.invalidName = 'This field cannot left blank'
        formIsValid = false
      }
      else if(this.formData.name =='' ){
        this.invalidName = 'This field cannot left blank'
        formIsValid = false

      }else if(!this.regex.name.test(this.formData.name)){
        this.invalidName = 'Template Name cannot contain special characters or numbers'
        formIsValid = false

      }else if(this.formData.name.length > 20){
        this.invalidName  = 'Template Name must be no longer than 20 characters'
      }

      //department
      if(this.formData.department == null){
        this.invalidDepartment = 'This field cannot left blank'
        formIsValid = false
      }

      //template category
      if(this.formData.template_category == null){
        this.invalidTemplateCategory = 'This field cannot left blank'
        formIsValid = false
      }


      if(formIsValid){
        return true
      }
      else{
        return false
      }
    },

    //check authentication
    validateToken:function (){
      var component = this

      axios.post(component.$base_url+'/agent/checkAuthentication', {
        auth_token:component.$root.agentAuthToken
      })
          .then(function (data) {
            var array =[]
            array = data.data


            console.log(array.data.message)
            if(array.success == true){
              console.log(array.data.message)
              //load department & template ctg
              component.getDataList()

            }else{
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }

          })
          .catch(function (error) {
            var array =[]
            array = error.response
            //session expired
            console.log(array.data.success)
            if(array.data.success == false){
              component.$buefy.toast.open({
                message: 'Authentication failed',
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }
          });

    },

    validateAndSubmit: function(){
      if(this.validateForm()){
        this.submitForm()
      }
      else{
        this.formIsInvalid = true
      }
    },

    submitForm:function (){
      var component = this
      component.formIsSubmitting = true

        axios.post(component.$base_url+'/agent/updateTemplateInitials', {
          auth_token:component.$root.agentAuthToken,
          department:component.formData.department,
          template_category:component.formData.template_category,
          name:component.formData.name,
          template_id:component.$route.params.id
        })
          .then(function (data) {
            component.formIsSubmitting = false
            var array =[]
            array = data.data

            if(array.success == true){
              console.log(array)
              component.$buefy.toast.open({
                message: array.message,
                type: 'is-success'
              })
              component.firstStep = false

              //append placeholders
              component.oldCoordinates.forEach((item)=>{
                if(item.type == 'text-box'){
                  component.textBoxes.push({
                    Xcord:item.Xcord,
                    Ycord:item.Ycord,
                    id:item.id,
                    type:item.type,
                    value:item.value
                  })
                }

                if(item.type == 'checkbox'){
                  component.checkboxes.push({
                    Xcord:item.Xcord,
                    Ycord:item.Ycord,
                    id:item.id,
                    type:item.type,
                    value:item.value
                  })
                }

                if(item.type == 'date-picker'){
                  component.datepickers.push({
                    Xcord:item.Xcord,
                    Ycord:item.Ycord,
                    id:item.id,
                    type:item.type,
                    value:item.value
                  })
                }

                if(item.type == 'signature'){
                  component.signatures.push({
                    Xcord:item.Xcord,
                    Ycord:item.Ycord,
                    id:item.id,
                    type:item.type,
                    value:item.value
                  })
                }

                setTimeout(() => {
                  component.AppendPlaceholdersToBody(item.id,item.type,item.Xcord,item.Ycord)
                }, 300)

              })
            }

          })
          .catch(function (error) {
            console.log(error.response)
          });
    },

    renderPDFdatabasePath:function (){
      var component = this
      var url = component.$base_public_url+component.document_url;
      console.log('url---------'+url)
      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      var loadingTask = pdfjsLib.getDocument(url);

      loadingTask.promise.then(function(pdf) {
        console.log('PDF loaded');

        // Fetch the first page
        var totalpages = pdf.numPages;
        component.TotPage = totalpages

        for(var x= 1; x <= totalpages; x++){
          component.Pageindex.push({pageIndex:x})
        }

        if(totalpages > 1) {
          component.Pageindex.forEach((element)=>{
            pdf.getPage(element.pageIndex).then(function(page) {
              console.log('Page loaded');

              var scale = 1.5;
              var viewport = page.getViewport({scale: scale});

              // Prepare canvas using PDF page dimensions
              var canvas = document.getElementById('the-canvas'+element.pageIndex);

              var context = canvas.getContext('2d');
              canvas.height = viewport.height;
              canvas.width = viewport.width;

              // Render PDF page into canvas context
              var renderContext = {
                canvasContext: context,
                viewport: viewport
              };
              var renderTask = page.render(renderContext);
              renderTask.promise.then(function () {
                console.log('Page rendered');
              });
            });
          })
        }else{
          var pagenumber = 1;
          pdf.getPage(pagenumber).then(function(page) {
            console.log('Page loaded');

            var scale = 1.5;
            var viewport = page.getViewport({scale: scale});

            // Prepare canvas using PDF page dimensions
            var canvas = document.getElementById('the-canvas1');

            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            // Render PDF page into canvas context
            var renderContext = {
              canvasContext: context,
              viewport: viewport
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(function () {
              console.log('Page rendered');
            });
          });
        }


      }, function (reason) {
        // PDF loading error
        console.error(reason);
      });
    },

    //render pdf (chnage document)
    renderPDF:function (){
      var component = this
      var  url = component.currentFileUrl

      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker
      var loadingTask = pdfjsLib.getDocument(url)

      loadingTask.promise.then(function(pdf) {
        console.log('PDF loaded');

        // Fetch the first page

        var totalpages = pdf.numPages;
        component.TotPage = totalpages
        console.log("Total pages : "+totalpages)

        for(var x = 1; x <= totalpages; x++){
          console.log("current page index : "+x)
          component.Pageindex.push({pageIndex:x})
        }

        if(totalpages > 1) {
          component.Pageindex.forEach((element)=>{
            pdf.getPage(element.pageIndex).then(function(page) {
              console.log('Page loaded');

              var scale = 1.5;
              var viewport = page.getViewport({scale: scale});

              // Prepare canvas using PDF page dimensions
              var canvas = document.getElementById('the-canvas'+element.pageIndex);

              var context = canvas.getContext('2d');
              canvas.height = viewport.height;
              canvas.width = viewport.width;

              // Render PDF page into canvas context
              var renderContext = {
                canvasContext: context,
                viewport: viewport
              };
              var renderTask = page.render(renderContext);
              renderTask.promise.then(function () {
                console.log('Page rendered');
              });
            });
          })
        }else{
          var pagenumber = 1;
          pdf.getPage(pagenumber).then(function(page) {
            console.log('Page loaded');

            var scale = 1.5;
            var viewport = page.getViewport({scale: scale});

            // Prepare canvas using PDF page dimensions
            var canvas = document.getElementById('the-canvas1');

            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            // Render PDF page into canvas context
            var renderContext = {
              canvasContext: context,
              viewport: viewport
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(function () {
              console.log('Page rendered');
            });
          });
        }



      }, function (reason) {
        // PDF loading error
        console.error(reason);
      });


    },

    savePDFwithCoordinates:function (){
      var component = this

      if(component.textBoxes.length > 0 || component.signatures.length >0 || component.datepickers.length >0 || component.checkboxes.length>0) {
        component.isSaveSubmitting = true //set loading true
        //save pdf into database
        event.preventDefault()
        component.getAllCooridinatesBeforeSave()

        if(component.oldCoordinates){
          if(component.oldCoordinates.length > 0){
            component.coordinates.concat(component.oldCoordinates)
            console.log(component.coordinates);
          }
        }

        // console.log(component.coordinates);

        axios.post(component.$base_url+'/agent/templateDocumentUpdate',{
          templateID:component.$route.params.id,
          old_file:component.document_url,
          new_file:component.file,
          auth_token:component.$root.agentAuthToken,
          coordinates:JSON.stringify(component.coordinates),

        },{
          headers:{'content-type':'multipart/form-data'},

        })
            .then(function (response){
              var arr = [];
              arr = response.data
              if(arr.success == true){
                component.$buefy.toast.open({
                  message: 'Successfully Saved',
                  type: 'is-success'
                })

                component.$router.push({name:'templateList'})

              }else{
                component.$buefy.toast.open({
                  message: 'Failed to save document',
                  type: 'is-danger'
                })
              }

            })
            .catch(function (error) {
              console.log(error);
            });


      }else{
        component.$buefy.toast.open({
          message: 'Please make sure to add place holders into the document',
          type: 'is-danger',
          duration:3000
        })
      }


    },


    getAllCooridinatesBeforeSave:function (){
      var component = this

      try{

        //for text box-------------------------------------------------------------
        component.textBoxes.forEach((textbox)=>{

          //get element x & y coordinates
          var placeholder = document.getElementById(textbox.id)

          const style = window.getComputedStyle(placeholder)
          const matrix = style.transform || style.webkitTransform || style.mozTransform

          const matrixType = matrix.includes('3d') ? '3d' : '2d'
          const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')
          if (matrixType === '2d') {
            const x = matrixValues[4]
            const y = matrixValues[5]

            //save coordinates values into the array
            component.coordinates.push(
                {
                  id:textbox.id,
                  Xcord:x,
                  Ycord:y,
                  type:textbox.type,
                  value:''
                })
          }

        })


        //for signatures-------------------------------------------------------------
        component.signatures.forEach((signature)=>{

          //get element x & y coordinates
          var placeholder = document.getElementById(signature.id)
          const style = window.getComputedStyle(placeholder)
          const matrix = style.transform || style.webkitTransform || style.mozTransform

          const matrixType = matrix.includes('3d') ? '3d' : '2d'
          const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')
          if (matrixType === '2d') {
            const x = matrixValues[4]
            const y = matrixValues[5]

            //save coordinates values into the array
            component.coordinates.push(
                {
                  id:signature.id,
                  Xcord:x,
                  Ycord:y,
                  type:signature.type,
                  value:''
                })
          }

        })


        //for checkbox-------------------------------------------------------------
        component.checkboxes.forEach((checkbox)=>{

          //get element x & y coordinates
          var placeholder = document.getElementById(checkbox.id)
          const style = window.getComputedStyle(placeholder)
          const matrix = style.transform || style.webkitTransform || style.mozTransform

          const matrixType = matrix.includes('3d') ? '3d' : '2d'
          const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')
          if (matrixType === '2d') {
            const x = matrixValues[4]
            const y = matrixValues[5]

            //save coordinates values into the array
            component.coordinates.push(
                {
                  id:checkbox.id,
                  Xcord:x,
                  Ycord:y,
                  type:checkbox.type,
                  value:''
                })
          }

        })

        //for datepicker-------------------------------------------------------------
        component.datepickers.forEach((datepciker)=>{

          //get element x & y coordinates
          var placeholder = document.getElementById(datepciker.id)
          const style = window.getComputedStyle(placeholder)
          const matrix = style.transform || style.webkitTransform || style.mozTransform

          const matrixType = matrix.includes('3d') ? '3d' : '2d'
          const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')
          if (matrixType === '2d') {
            const x = matrixValues[4]
            const y = matrixValues[5]

            //save coordinates values into the array
            component.coordinates.push(
                {
                  id:datepciker.id,
                  Xcord:x,
                  Ycord:y,
                  type:datepciker.type,
                  value:''
                })
          }

        })

        return true
      }catch (error){

        console.log(error)
        return false
      }

    },


  },

  mounted() {
    this.validateToken()
    this.getItemforEdit()
    this.renderPDFdatabasePath()
  },

}

</script>
<style scoped>
#dashboardItemTitle{
  color: #A5A6B3;
  font-weight: 600;
  font-size: 30px;
  text-align: left
}

.help{
  float: left;
}

.upload-area{
  text-align: center;
  width: 70%;
  padding: 10px;
  border: 5px rgba(14, 98, 171, 0.5) dashed;
  border-radius: 20px;
  margin: auto;
  margin-top: 30px;
  position: relative;

}

.upload-area img{
  opacity: 50%;
}

#docButton{
  background-color: white;
  z-index: 1;
  margin:0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}

#drop-zone{
  width: 80%;
  height:100%;
  margin-left: 80px;
}

.box{
  box-shadow: 0px 9px 17px rgba(0, 0, 0, 0.1);
  height: 100%;
}

.area{
  height: 100%;
  width: 100%;
  background-color: #F2F4FF;
  padding: 10px;
}

.draggable {
  position: absolute;
  transition: all 0.3s ease-in-out;
}
</style>
